import { createContext } from 'react'
import { FieldValues, UseFieldArrayReturn } from 'react-hook-form'

export const DetailManyToOneContext = createContext<{
  name: string | number | symbol
  array: UseFieldArrayReturn<FieldValues, any, 'id'>
}>({
  name: '',
})

export const DetailManyToOneProvider = ({
  name,
  array,
  children,
}: {
  name: string | number | symbol
  array: UseFieldArrayReturn<FieldValues, any, 'id'>
  children: React.ReactNode
}) => {
  return (
    <DetailManyToOneContext.Provider value={{ name, array }}>
      {children}
    </DetailManyToOneContext.Provider>
  )
}
